import { render, staticRenderFns } from "./AnalogueClockWidget.vue?vue&type=template&id=4f05b24c&scoped=true&"
import script from "./AnalogueClockWidget.vue?vue&type=script&lang=ts&"
export * from "./AnalogueClockWidget.vue?vue&type=script&lang=ts&"
import style0 from "./AnalogueClockWidget.vue?vue&type=style&index=0&id=4f05b24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05b24c",
  null
  
)

export default component.exports